import defaultLanguage from '../assets/language/language.js';
console.log('default language', defaultLanguage);

let language = null;
if (process.env.TARGET_APP && process.env.TARGET_APP !== 'default') {
    language = require('../assets/language/language.' + process.env.TARGET_APP + '.js');
    console.log('app languauge', language);
}
let mergeLanguage = {};
if (language) {
    if (language.default && language.default.first) {
        for (const key in defaultLanguage) {
            if (defaultLanguage.hasOwnProperty(key)) {
                // console.log(key, defaultLanguage[key], language.default[key]);
                if (defaultLanguage[key].toString() === '[object Object]') {
                    mergeLanguage[key] = Object.assign(defaultLanguage[key], language.default[key]);
                } else {
                    mergeLanguage[key] = language.default[key] ? language.default[key] : defaultLanguage[key];
                }
            }
        }
    } else {
        mergeLanguage = Object.assign(defaultLanguage, language.default);
    }
} else {
    mergeLanguage = defaultLanguage;
}

class LanguageManager {
    constructor (language) {
        this.localLanguage = language.first ? language.first : 'es';
        let storageLanguage = window.localStorage.getItem('local_lang');
        if (storageLanguage) {
            this.localLanguage = storageLanguage;
        }
        console.log('localLanguage', this.localLanguage);
    }
    getLang () {
        return this.localLanguage;
    }
    setLang (lang) {
        this.localLanguage = lang;
        window.localStorage.setItem('local_lang', lang);
        console.log('LangManager setLang', lang);
        return true;
    }
    translateFromText (text) {
        let textKey = null;
        for (const key in mergeLanguage) {
            if (mergeLanguage.hasOwnProperty(key) && key !== 'first') {
                for (const keyPair in mergeLanguage[key]) {
                    if (mergeLanguage[key].hasOwnProperty(keyPair)) {
                        if (mergeLanguage[key][keyPair] === text) {
                            textKey = keyPair;
                            break;
                        }
                    }
                }
            }
        }
        if (textKey) {
            return mergeLanguage[this.localLanguage][textKey];
        } else {
            return text;
        }
    }
    translate (key) {
        return mergeLanguage[this.localLanguage][key];
    }
}

export default mergeLanguage;

let _manager = new LanguageManager(mergeLanguage);

export let LangManager = _manager;



// WEBPACK FOOTER //
// ./src/services/language.js